export function getUrl(item) {
  if (item.document.hasOwnProperty("rental.id")) {
    return `/admin/rental/edit/${item.document.id}`;
  }
  if (item.document.hasOwnProperty("employee.id")) {
    return `/admin/organisation/employee/${item.document.id}/edit`;
  }
  if (item.document.hasOwnProperty("case_item.id")) {
    return `/admin/case-item/edit/${item.document.id}`;
  }
  if (item.document.hasOwnProperty("invoice.id")) {
    return `/admin/payment/invoices/show/${item.document.id}`;
  }
  if (item.document.hasOwnProperty("phone_plan.id")) {
    return `/admin/organisation/phonePlan/${item.document.id}/edit`;
  }
  if (item.document.hasOwnProperty("organisation.id")) {
    return `/admin/organisation/organisation/${item.document.id}`;
  }
  if (item.document.hasOwnProperty("return_case.id")) {
    return `/admin/v2/#/return-cases/${item.document.id}/edit`;
  }
}

export function handleGlobalSearchClick(item) {
  const url = getUrl(item);
  window.location.replace(url);
}

export function capitalize(s) {
  return s && s[0].toUpperCase() + s.slice(1);
}
